/** The width/height shape a node's photo currently has on the canvas, if any. */
export function renderedImageRatio(nodeId: string): number | null {
  if (typeof document === "undefined") return null;
  const selector = `.zirro-canvas-area [data-node-id="${CSS.escape(nodeId)}"]`;
  const box = document.querySelector(`${selector} [data-image-frame]`) ?? document.querySelector(`${selector} img`);
  if (!box) return null;
  const { width, height } = box.getBoundingClientRect();
  return width > 0 && height > 0 ? width / height : null;
}
